import { useCallback } from "react";
import { useAudioPlayback } from "@/common/hooks/useAudioPlayback.ts";
import useCurrentExplorerItem from "@/common/hooks/useCurrentExplorerItem.ts";
import useKeyboardListener from "@/common/hooks/useKeyboardListener";
import { useKeyboardShortcutAudioControl } from "./useKeyboardShortcutAudioControl";
import { KeyboardEventHandlerOptions } from "@/types/types.ts";

export const useKeyboardShortcutPlayPreviousTrack = (options?: KeyboardEventHandlerOptions): void => {
  const { withShortcutCheck } = useKeyboardShortcutAudioControl(options);
  const currentExplorerItem = useCurrentExplorerItem();
  const { playPreviousTrack } = useAudioPlayback();

  const playPrevious = useCallback((): void => {
    if (currentExplorerItem) {
      playPreviousTrack(currentExplorerItem);
    }
  }, [
    currentExplorerItem,
    playPreviousTrack
  ]);

  useKeyboardListener(
    withShortcutCheck((event) => {
      if (event.key === "ArrowLeft" && (event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        playPrevious();
      }
    })
  );
};
